import { render, staticRenderFns } from "./FeaturedJobs.vue?vue&type=template&id=b202bfa0&"
import script from "./FeaturedJobs.vue?vue&type=script&lang=js&"
export * from "./FeaturedJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports